import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  systemSelected: "",
};

export const systemSelectionSlice = createSlice({
  name: "systemSelection",
  initialState,
  reducers: {
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    setSystemSelected: (state, action) => {
      state.systemSelected = action.payload;
    },
  },
});

export const { goToPage, setSystemSelected } = systemSelectionSlice.actions;
export default systemSelectionSlice.reducer;
